// extracted by mini-css-extract-plugin
export default {"container":"labelValuePair_container__jPH7w","key":"labelValuePair_key__c+YEQ","record-key":"labelValuePair_record-key__Vclp0"};